import React from "react";
import { useTranslation } from "react-i18next";
import RuleBodyPage from "components/common/RuleBodyPage";
import { RuleModalBodyProps } from "components/common/RuleModal";

function TeamBuilderRuleBody({ page }: RuleModalBodyProps) {
  const { t } = useTranslation();
  const rules = t("TeamBuilder.rules", { returnObjects: true }) as string[];

  const phaseContainer =
    "flex items-center gap-3 p-3 bg-gray-800 rounded-lg mb-4";
  const iconContainer =
    "w-8 h-8 min-w-9 min-h-9 flex items-center justify-center rounded-full text-sm";

  return (
    <div className="relative flex">
      {/* Page 1: 게임 소개 */}
      <RuleBodyPage show={page === 0}>
        <div className="space-y-4">
          <div className="text-gray-100">{rules[0]}</div>
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-green-600`}>
              <i className="fas fa-edit" />
            </div>
            <div>
              <div className="font-medium text-green-300 mb-1">{rules[1]}</div>
              <div className="text-sm text-gray-300">{rules[2]}</div>
            </div>
          </div>

          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-blue-600`}>
              <i className="fas fa-cogs" />
            </div>
            <div>
              <div className="font-medium text-blue-300 mb-1">{rules[3]}</div>
              <div className="text-sm text-gray-300">{rules[4]}</div>
            </div>
          </div>

          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-purple-600`}>
              <i className="fas fa-play" />
            </div>
            <div>
              <div className="font-medium text-purple-300 mb-1">{rules[5]}</div>
              <div className="text-sm text-gray-300">{rules[6]}</div>
            </div>
          </div>

          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-yellow-600`}>
              <i className="fas fa-eye" />
            </div>
            <div>
              <div className="font-medium text-yellow-300 mb-1">{rules[7]}</div>
              <div className="text-sm text-gray-300">{rules[8]}</div>
            </div>
          </div>
        </div>
      </RuleBodyPage>

      {/* Page 2: 사용 방법 */}
      <RuleBodyPage show={page === 1}>
        <div className="space-y-4">
          <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
            <div className="font-medium text-green-300 mb-2">{rules[9]}</div>
            <div className="text-sm text-gray-300">
              {rules[10]}
              <br />
              {rules[11]}
              <br />
              <span className="text-green-200">{rules[12]}</span>
            </div>
          </div>
        </div>
        <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
          <div className="font-medium text-indigo-300 mb-2">{rules[13]}</div>
          <div className="text-sm text-gray-300 space-y-1">
            <div>{rules[14]}</div>
            <div className="text-blue-300">{rules[15]}</div>
            <div className="text-green-300">{rules[16]}</div>
            <div className="text-purple-300">{rules[17]}</div>
          </div>
        </div>
        <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
          <div className="font-medium text-indigo-300 mb-2">{rules[18]}</div>
          <div className="text-sm text-gray-300 space-y-1">
            <div>{rules[19]}</div>
            <div className="text-blue-300">{rules[20]}</div>
            <div className="text-green-300">{rules[21]}</div>
            <div className="text-purple-300">{rules[22]}</div>
            <div className="text-red-300">{rules[23]}</div>
          </div>
        </div>
      </RuleBodyPage>

      {/* Page 4: 활용 분야 및 팁 */}
      {/* <RuleBodyPage show={page === 3}>
        <div className="text-xl font-bold text-blue-400 mb-4">
          활용 분야 & 팁
        </div>
        <div className="space-y-4">
          <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
            <div className="font-medium text-green-300 mb-2">활용 분야</div>
            <div className="grid grid-cols-2 gap-2 text-sm">
              <div className="text-blue-200">• 스포츠 활동</div>
              <div className="text-green-200">• 교육 활동</div>
              <div className="text-purple-200">• 게임 활동</div>
              <div className="text-red-200">• 회사 이벤트</div>
            </div>
          </div>

          <div className="bg-orange-900/20 border border-orange-700/30 p-4 rounded-lg">
            <div className="font-medium text-orange-300 mb-2">주의사항</div>
            <ul className="list-disc list-inside space-y-2 text-sm text-orange-200">
              <li>총 인원은 최소 2명 이상이어야 합니다</li>
              <li>팀 개수는 최소 2팀 이상, 총 인원보다 적어야 합니다</li>
              <li>
                인원이 균등하게 나누어지지 않으면 일부 팀이 1명 더 많을 수
                있습니다
              </li>
              <li>다시 편성 시 팀 배정이 완전히 바뀝니다</li>
            </ul>
          </div>

          <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
            <div className="font-medium text-green-300 mb-2">활용 팁</div>
            <ul className="list-disc list-inside space-y-2 text-sm text-gray-300">
              <li>스포츠 경기, 토론, 게임 등 다양한 활동에 활용 가능합니다</li>
              <li>플레이어 번호를 미리 배정해두면 더 편리합니다</li>
              <li>결과를 스크린샷으로 저장해두면 나중에 참고할 수 있습니다</li>
              <li>팀 이름을 미리 정해두면 더 재미있게 진행할 수 있습니다</li>
            </ul>
          </div>
        </div>
      </RuleBodyPage> */}
    </div>
  );
}

export default TeamBuilderRuleBody;
